module.exports = __webpack_public_path__ + "static/media/h4_legaled_bw.660b9b9f.webp";